import { render, staticRenderFns } from "./AccessControlTable.vue?vue&type=template&id=747848b8&"
import script from "./AccessControlTable.vue?vue&type=script&lang=js&"
export * from "./AccessControlTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports